import React, { useState } from "react";
import {
    Drawer,
    Spin,
    Collapse,
    Pagination,
    Button,
    Tag,
    Empty,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import NumberFormat from "react-number-format";

const BikerTransactions = ({
    transactions,
    pagination,
    loading,
    onRefresh,
    onPageChange,
}) => {
    const spinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    const [selectedTrans, setSelectedTrans] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const handleViewClick = (trans) => {
        setSelectedTrans(trans);
        setDrawerVisible(true);
    };

    const handlePageChange = (page, pageSize) => {
        onPageChange(page, pageSize);
    };

    return (
        <div>
            <Spin indicator={spinnerIcon} spinning={loading}>
                <div className="mt history-data-detail">
                    <div className="contai">
                        {!loading ? (
                            <>
                                {transactions?.length === 0 ? (
                                    <Empty description="No transactions found">
                                        <Button type="primary" onClick={onRefresh}>
                                            Refresh
                                        </Button>
                                    </Empty>
                                ) : (
                                    <div className="mobile topup-data">
                                        <Collapse defaultActiveKey={[0]}>
                                            {transactions.map((trans, index) => (
                                                <Collapse.Panel
                                                    showArrow={false}
                                                    key={index}
                                                    header={
                                                        <p style={{ display: "inline" }}>
                                                            {trans.description} -{" "}
                                                            {new Date(trans.createdAt).toLocaleString()}
                                                        </p>
                                                    }
                                                >
                                                    <div>
                                                        <ul className="mobile-list-flex">
                                                            <li>
                                                                <span>Date: </span>
                                                                <span>
                                                                    {new Date(trans.createdAt).toLocaleString()}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span>Ref Code: </span>
                                                                <span>#{trans.externalRef || trans.id}</span>
                                                            </li>
                                                            <li>
                                                                <span>Amount: </span>
                                                                <span>
                                                                    ₦
                                                                    <NumberFormat
                                                                        thousandSeparator={true}
                                                                        prefix={""}
                                                                        className="numeric"
                                                                        displayType={"text"}
                                                                        value={parseFloat(trans.amount).toFixed(2)}
                                                                    />{" "}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span>Type: </span>
                                                                <span>
                                                                    <Tag
                                                                        color={
                                                                            trans.type === "CREDIT" ? "green" : "red"
                                                                        }
                                                                    >
                                                                        {trans.type}
                                                                    </Tag>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span>Status: </span>
                                                                <span>
                                                                    <Tag
                                                                        color={
                                                                            trans.status === "SUCCESSFUL"
                                                                                ? "green"
                                                                                : "orange"
                                                                        }
                                                                    >
                                                                        {trans.status.toLowerCase()}
                                                                    </Tag>
                                                                </span>
                                                            </li>
                                                            {trans.hasFee && (
                                                                <li>
                                                                    <span>Fee: </span>
                                                                    <span>
                                                                        ₦{parseFloat(trans.feeAmount || 0).toFixed(2)}
                                                                    </span>
                                                                </li>
                                                            )}
                                                        </ul>
                                                        <div className="mt-3">
                                                            <Button
                                                                onClick={() => handleViewClick(trans)}
                                                                type="link"
                                                            >
                                                                View Details
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Collapse.Panel>
                                            ))}
                                        </Collapse>
                                        <div style={{ marginTop: "2%" }}></div>
                                        <Pagination
                                            showSizeChanger
                                            current={pagination?.page}
                                            total={pagination?.total}
                                            showTotal={(total, range) =>
                                                `${range[0]}-${range[1]} of ${total} transactions`
                                            }
                                            defaultPageSize={pagination?.limit}
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                )}
                            </>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </Spin>

            <Drawer
                title="Transaction Details"
                placement="bottom"
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
                className={"px-8 h-[80vh]"}
                width={720}
                height="100%"
            >
                {selectedTrans && (
                    <div className="space-y-4">
                        <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                            <div className="text-gray-600">Ref Code</div>
                            <div className="text-2xl font-bold text-gray-900 font-mono">
                                #{selectedTrans.externalRef || selectedTrans.id}
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                            <div className="p-3 bg-gray-50 rounded-lg">
                                <div className="text-xs text-gray-600 uppercase font-semibold">
                                    Type
                                </div>
                                <div className="mt-2">
                                    <Tag
                                        color={selectedTrans.type === "CREDIT" ? "green" : "red"}
                                        style={{ fontSize: "12px", padding: "4px 8px" }}
                                    >
                                        {selectedTrans.type}
                                    </Tag>
                                </div>
                            </div>
                            <div className="p-3 bg-gray-50 rounded-lg">
                                <div className="text-xs text-gray-600 uppercase font-semibold">
                                    Status
                                </div>
                                <div className="mt-2">
                                    <Tag
                                        color={
                                            selectedTrans.status === "SUCCESSFUL" ? "green" : "orange"
                                        }
                                        style={{ fontSize: "12px", padding: "4px 8px" }}
                                    >
                                        {selectedTrans.status}
                                    </Tag>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                            <div className="text-gray-600 mb-1">Amount</div>
                            <div className="text-3xl font-bold text-green-600">
                                <NumberFormat
                                    thousandSeparator={true}
                                    prefix="₦"
                                    displayType="text"
                                    value={parseFloat(selectedTrans.amount || 0).toFixed(2)}
                                />
                            </div>
                        </div>

                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                            <div className="flex justify-between items-start">
                                <span className="text-gray-600 font-semibold">Date</span>
                                <span className="text-gray-900 font-medium">
                                    {new Date(selectedTrans.createdAt).toLocaleString()}
                                </span>
                            </div>
                            <div className="flex justify-between items-start border-t pt-2">
                                <span className="text-gray-600 font-semibold">Description</span>
                                <span className="text-gray-900 font-medium text-right">
                                    {selectedTrans.description}
                                </span>
                            </div>
                            {selectedTrans.tag && (
                                <div className="flex justify-between items-start border-t pt-2">
                                    <span className="text-gray-600 font-semibold">Tag</span>
                                    <span className="text-gray-900 font-medium">
                                        {selectedTrans.tag}
                                    </span>
                                </div>
                            )}
                        </div>

                        {selectedTrans.hasFee && (
                            <div className="space-y-3 p-4 bg-orange-50 rounded-lg border border-orange-200">
                                <div className="font-semibold text-orange-900 mb-3">
                                    Fee Details
                                </div>
                                <div className="flex justify-between items-center py-2">
                                    <span className="text-gray-700">Transfer Amount</span>
                                    <span className="font-semibold text-gray-900">
                                        <NumberFormat
                                            thousandSeparator={true}
                                            prefix="₦"
                                            displayType="text"
                                            value={parseFloat(
                                                selectedTrans.transferAmount || 0,
                                            ).toFixed(2)}
                                        />
                                    </span>
                                </div>
                                <div className="border-t border-orange-200"></div>
                                <div className="flex justify-between items-center py-2">
                                    <span className="text-gray-700">Fee Amount</span>
                                    <span className="font-semibold text-red-600">
                                        <NumberFormat
                                            thousandSeparator={true}
                                            prefix="₦"
                                            displayType="text"
                                            value={parseFloat(selectedTrans.feeAmount || 0).toFixed(2)}
                                        />
                                    </span>
                                </div>
                                <div className="border-t border-orange-200"></div>
                                <div className="flex justify-between items-start py-2">
                                    <span className="text-gray-700">Fee Description</span>
                                    <span className="font-medium text-gray-900 text-right">
                                        {selectedTrans.feeDescription}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Drawer>
        </div>
    );
};

export default BikerTransactions;
